<template>
  <div class="w98">
   <div class="crumb">
      <span><router-link to="/Help">帮助</router-link>  > </span>
      <span>名师讲堂</span>
    </div>
     <help-Menu></help-Menu>
    <div class="rightContent">
        <div class="conten">
          <P class="text">点击tab【名师讲堂】，可默认查询当前所有上传过课程，课程数不为0的用户。（以下课程都特指对当前登陆用户有开放权限且已上架的课程，没有权限没上架的不显示在教学中心）。</P>
          <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
                 课程查询
            </template>
            <p class="text">查询： 可在搜索框内输入课程名和专家名（支持模糊查询），也可选择已设置好的查询条件（医生职称、所属医院）对名师进行查询。</p>
            <P class="text">排序：名师默认按照“点赞最多”来进行排序。点击下拉排序方式，除“点赞最多”之外，还有“观看最多”“课程最多”。若有相应的名师，则会在查询结果区显示，若无，则会提示 “未查询到符合条件记录”。</P>
            <P class="text">点击名师头像和更多按钮，进入名师详情页，直接点击某课程则进入课程详情页。如图所示：</P>
            <div><img src="../../../../static/image/60.png"/></div>
          </el-collapse-item>
          <el-collapse-item title="名师详情">
            <P class="text">名师详情页显示名师基本信息、课程数、学习人数，以及名师所上传对当前用户有权限的课程，点击课程进入“课程详情页”可开始学习。</P>
            <div><img src="../../../../static/image/61.png"/></div>
          </el-collapse-item>
        </el-collapse>

      </div>
    </div>
</div>
</template>

<script type="text/ecmascript-6">
  import {getRightHeight} from '@/common/js/rightHeight'
  import helpHead from '@/components/common/header/helpHead'
  import helpMenu from '@/components/common/helpMenu/helpMenu'
  export default {
    data () {
      return {
         height:''
      }
    },
    components:{
        helpHead,
        helpMenu
    },
      mounted() {
      setTimeout(() => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      }, 20)
      window.addEventListener('resize', () => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      })
    },
}

</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.content
    min-width: 100vw
    height: 100vh
    overflow: hidden
 .rightContent
    position: relative
    float: right
    height :calc(100vh - 80px)
    width: calc(80% - 1px)
    min-width: 919px
    background :#fff
    overflow:auto
  .conten
     padding: 25px 25px 25px 30px
  .titleBar
     color:#000
     font-size:14px
     font-weight:bolder
  .text
     color:#555
     line-height: 25px
     text-indent:2em
  .textlittle
    text-indent:4em
  img
   width:80%
 .crumb
 line-height: 30px
 margin: 5px 0 0 20px

</style>



// WEBPACK FOOTER //
// ThematicRead.vue?8848811e